import React, { Suspense } from 'react';
import { Provider, ReactReduxContext } from 'react-redux';
import { Router } from 'react-router-dom';
import { ConfigProvider as ConfigProviderV5 } from 'antd-v5';
import { ROUTER_SILENT_TOKEN_RENEW } from 'app/AppRouter';
import AppRouterContainer from 'app/AppRouterContainer';
import Loader from 'components/Loader';
import SilentRenew from 'components/SilentRenew';
import { ErrorBoundary } from 'composers/ErrorBoundary';
import { antLessTheme } from 'styles/antLessTheme';
import { Theme } from 'UI';
import { browserHistory } from 'utils/history';
import { GlobalStyle } from './App.styled';
import 'antd/dist/antd.less';
import 'react-quill/dist/quill.core.css';
import 'react-quill/dist/quill.snow.css';
import { globalStore } from './AppStore';
import 'react-image-crop/dist/ReactCrop.css';
import ReloadInit from './ReloadInit';
import 'moment/locale/de';
import 'moment/locale/de-at';
import 'moment/locale/de-ch';
import 'moment/locale/es';
import 'moment/locale/es-us';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/it-ch';
import 'moment/locale/nl';
import 'moment/locale/nl-be';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/pt-br';
import 'moment/locale/ro';
import 'moment/locale/tr';
import 'moment/locale/cs';
import 'moment/locale/sk';
import 'moment/locale/en-in';
import 'moment/locale/lb';
import 'moment/locale/ru';
import 'moment/locale/en-gb';

export const App = () => {
  // For OIDC silent renewal, we need to render minimal page and avoid AppRouter.
  // AppRouter has many side effects such as establishing another WS connection.
  // This could have caused error "Handshake failed due to invalid Upgrade header: null"
  if (globalThis.location.pathname === ROUTER_SILENT_TOKEN_RENEW) {
    return <SilentRenew />;
  }

  return (
    <Provider store={globalStore} context={ReactReduxContext}>
      <ConfigProviderV5 prefixCls={'ant5'} theme={antLessTheme}>
        <ReloadInit />
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>
            <Router history={browserHistory}>
              <Theme>
                <GlobalStyle />
                <AppRouterContainer />
              </Theme>
            </Router>
          </Suspense>
        </ErrorBoundary>
      </ConfigProviderV5>
    </Provider>
  );
};
